import {RestaurantLocation} from "@/data/entities/restaurant";
import {User} from "@/data/entities/user";
import {api} from "@/data/api";

export type LoadedData = {
    user: User | null;
    restaurantLocations: RestaurantLocation[];
};

export const userLoader = async (): Promise<LoadedData> => {
    const user: User | null = await api.user.getCurrentUser();
    const restaurantLocations: RestaurantLocation[] = await api.restaurant.getRestaurantLocations();
    return {user, restaurantLocations};
};